import { AddressType } from '@rematter/frontend-lib-api-client';
import { AddressRecord } from '@rematter/modules/crm/_graphql/queryAccounts';
import * as state from '@rematter/modules/crm/_state/accountDetails.state';
import {
  Badge,
  FormattedAddress,
  SelectableCard,
  ThemeColors,
} from '@rematter/ui-web';
import { useAtom } from 'jotai';

export type AddressTypeBadgeProps = { addressType: AddressType };

const AddressTypeBadge = (props: AddressTypeBadgeProps) => (
  <Badge
    color={
      {
        Standard: ThemeColors.primary,
        POBox: ThemeColors.olive,
        NonStandard: ThemeColors.rust,
      }[props.addressType]
    }
    className="@AddressTypeBadge"
  >
    {props.addressType}
  </Badge>
);

export type AddressCardProps = {
  address: AddressRecord;
  isNextCardSelected?: boolean;
};

export const AddressCard = (props: AddressCardProps) => {
  const [selectedAddress, setSelectedAddress] = useAtom(state.$selectedAddress);

  const isSelected = selectedAddress?.id === props.address.id;

  return (
    <SelectableCard
      className="@AddressCard"
      onClick={() => setSelectedAddress(props.address)}
      isSelected={isSelected}
      isNextCardSelected={props.isNextCardSelected}
    >
      <div>
        <AddressTypeBadge addressType={props.address.addressType} />
      </div>
      <div className={'font-medium'}>{props.address.name}</div>
      <div className="text-xs opacity-70">
        <FormattedAddress singleLine {...props.address} />
      </div>
    </SelectableCard>
  );
};
